// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectWrapper__JzbRU {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.selectWrapper__JzbRU .select__dA9mi {
  min-width: 130px;
  min-height: 35px;
  padding: 0px 5px 0px 15px;
  border-radius: 2px;
  border: 1px solid var(--inputs-default-stroke, );
  background: var(--inputs-default-surface-default);
}
.selectWrapper__JzbRU .select__dA9mi:active, .selectWrapper__JzbRU .select__dA9mi:hover, .selectWrapper__JzbRU .select__dA9mi:focus-visible, .selectWrapper__JzbRU .select__dA9mi:focus-within {
  border: 1px solid var(--inputs-focus-stroke);
  background: var(--inputs-focus-surface-focus);
  box-shadow: none !important;
}
.selectWrapper__JzbRU .select__dA9mi:active svg, .selectWrapper__JzbRU .select__dA9mi:hover svg, .selectWrapper__JzbRU .select__dA9mi:focus-visible svg, .selectWrapper__JzbRU .select__dA9mi:focus-within svg {
  fill: var(--inputs-focus-stroke);
}
.selectWrapper__JzbRU .select__dA9mi .react-dropdown-select-dropdown {
  min-height: 32px;
  max-height: 350px;
  background: var(--inputs-default-surface-default);
  box-shadow: var(--select-dropdown-box-shadow);
  border: unset;
  border-radius: 2px;
  padding: unset;
}
.selectWrapper__JzbRU .select__dA9mi .react-dropdown-select-dropdown::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.selectWrapper__JzbRU .select__dA9mi .react-dropdown-select-dropdown::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.selectWrapper__JzbRU .select__dA9mi .react-dropdown-select-dropdown::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.selectWrapper__JzbRU .select__dA9mi .react-dropdown-select-dropdown::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
.selectWrapper__JzbRU .select__dA9mi .react-dropdown-select-dropdown .react-dropdown-select-no-data {
  color: var(--inputs-default-text);
  padding: 16px;
}
.selectWrapper__JzbRU .select__dA9mi .react-dropdown-select-type-single {
  color: var(--inputs-focus-text);
  flex-wrap: nowrap;
  align-items: center;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
}
.selectWrapper__JzbRU .select__dA9mi .react-dropdown-select-content span {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  color: var(--inputs-focus-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
}
.selectWrapper__JzbRU .select__dA9mi svg {
  fill: var(--inputs-default-icon);
}
.selectWrapper__JzbRU .select__dA9mi .react-dropdown-select-input {
  font-size: 12px;
  color: var(--inputs-focus-text);
}
.selectWrapper__JzbRU .selectFilled__tP6sY {
  border: 1px solid var(--inputs-filled-stroke);
  background: var(--inputs-filled-filled-surface);
}
.selectWrapper__JzbRU .selectFilled__tP6sY svg {
  fill: var(--inputs-filled-icon);
}
.selectWrapper__JzbRU .selectDisabled__TnNr2 {
  border: 1px solid var(--inputs-disable-stroke);
  background: var(--inputs-disable-disable-surface);
}
.selectWrapper__JzbRU .selectDisabled__TnNr2 .react-dropdown-select-type-single {
  color: var(--inputs-disable-text);
}
.selectWrapper__JzbRU .selectDisabled__TnNr2 svg {
  fill: var(--inputs-disable-icon);
}
.selectWrapper__JzbRU .selectError__zO8eo {
  border: 1px solid var(--inputs-error-stroke);
}

.selectLabel__BKAM1 {
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.selectItem__LhoBz {
  color: var(--inputs-focus-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  padding: 10px 10px;
  letter-spacing: 0.11px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
.selectItem__LhoBz:hover {
  font-weight: 500;
  letter-spacing: unset;
}
.selectItem__LhoBz:last-child {
  border-bottom: unset;
}

.activeItem__Pqy96 {
  font-weight: 500;
}

.disabledItem__ZDQjq {
  opacity: 0.5;
  pointer-events: none;
}

.rtl__geCmh {
  direction: rtl;
}

.helperText__zP2h4 {
  color: var(--inputs-error-text-helper);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  min-height: 11px;
  margin-top: 5px;
}

.required__rIhPo:after {
  content: "*";
  font-size: 10px;
  line-height: 12px;
  color: var(--inputs-error-stroke);
  margin-left: 4px;
}`, "",{"version":3,"sources":["webpack://./../src/components/uikit/Select/style.module.scss"],"names":[],"mappings":"AA6EA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AA5EF;AA8EE;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gDAAA;EACA,iDAAA;AA5EJ;AA8EI;EAIE,4CAAA;EACA,6CAAA;EACA,2BAAA;AA/EN;AAiFM;EACE,gCAAA;AA/ER;AAoFM;EACE,gBAAA;EACA,iBAAA;EACA,iDAAA;EACA,6CAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AAlFR;AAHE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAKJ;AAFE;EACE,+BAAA;EACA,kBAAA;AAIJ;AADE;EACE,8BAAA;EACA,kBAAA;AAGJ;AAAE;EACE,gBAAA;EACA,kBAAA;AAEJ;AAoEQ;EACE,iCAAA;EACA,aAAA;AAlEV;AAsEM;EACE,+BAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AApER;AAuEM;EACE,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AArER;AAwEM;EACE,gCAAA;AAtER;AAyEM;EACE,eAAA;EACA,+BAAA;AAvER;AA4EE;EACE,6CAAA;EACA,+CAAA;AA1EJ;AA4EI;EACE,+BAAA;AA1EN;AA8EE;EACE,8CAAA;EACA,iDAAA;AA5EJ;AA+EM;EACE,iCAAA;AA7ER;AAiFI;EACE,gCAAA;AA/EN;AAmFE;EACE,4CAAA;AAjFJ;;AAqFA;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AAlFF;;AAqFA;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yDAAA;AAlFF;AAoFE;EACE,gBAAA;EACA,qBAAA;AAlFJ;AAqFE;EACE,oBAAA;AAnFJ;;AAuFA;EACE,gBAAA;AApFF;;AAuFA;EACE,YAAA;EACA,oBAAA;AApFF;;AAuFA;EACE,cAAA;AApFF;;AAuFA;EACE,sCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AApFF;;AAwFE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,gBAAA;AArFJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n@import 'src/assets/variables.scss';\n@import 'src/assets/_mixins.scss';\n\n.selectWrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n\n  & .select {\n    min-width: 130px;\n    min-height: 35px;\n    padding: 0px 5px 0px 15px;\n    border-radius: 2px;\n    border: 1px solid var(--inputs-default-stroke,);\n    background: var(--inputs-default-surface-default);\n\n    &:active,\n    &:hover,\n    &:focus-visible,\n    &:focus-within {\n      border: 1px solid var(--inputs-focus-stroke);\n      background: var(--inputs-focus-surface-focus);\n      box-shadow: none !important;\n\n      svg {\n        fill: var(--inputs-focus-stroke);\n      }\n    }\n\n    :global {\n      .react-dropdown-select-dropdown {\n        min-height: 32px;\n        max-height: 350px;\n        background: var(--inputs-default-surface-default);\n        box-shadow: var(--select-dropdown-box-shadow);\n        border: unset;\n        border-radius: 2px;\n        padding: unset;\n        @include scrollBar;\n\n        .react-dropdown-select-no-data {\n          color: var(--inputs-default-text);\n          padding: 16px;\n        }\n      }\n\n      .react-dropdown-select-type-single {\n        color: var(--inputs-focus-text);\n        flex-wrap: nowrap;\n        align-items: center;\n        font-size: 11px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 12px;\n      }\n\n      .react-dropdown-select-content span {\n        overflow: hidden;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        line-clamp: 2;\n        -webkit-box-orient: vertical;\n        color: var(--inputs-focus-text);\n        font-size: 11px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 12px;\n      }\n\n      svg {\n        fill: var(--inputs-default-icon);\n      }\n\n      .react-dropdown-select-input {\n        font-size: 12px;\n        color: var(--inputs-focus-text);\n      }\n    }\n  }\n\n  & .selectFilled {\n    border: 1px solid var(--inputs-filled-stroke);\n    background: var(--inputs-filled-filled-surface);\n\n    svg {\n      fill: var(--inputs-filled-icon);\n    }\n  }\n\n  & .selectDisabled {\n    border: 1px solid var(--inputs-disable-stroke);\n    background: var(--inputs-disable-disable-surface);\n\n    :global {\n      .react-dropdown-select-type-single {\n        color: var(--inputs-disable-text);\n      }\n    }\n\n    svg {\n      fill: var(--inputs-disable-icon);\n    }\n  }\n\n  & .selectError {\n    border: 1px solid var(--inputs-error-stroke);\n  }\n}\n\n.selectLabel {\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n}\n\n.selectItem {\n  color: var(--inputs-focus-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  padding: 10px 10px;\n  letter-spacing: 0.11px;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n\n  &:hover {\n    font-weight: 500;\n    letter-spacing: unset;\n  }\n\n  &:last-child {\n    border-bottom: unset;\n  }\n}\n\n.activeItem {\n  font-weight: 500;\n}\n\n.disabledItem {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.rtl {\n  direction: rtl;\n}\n\n.helperText {\n  color: var(--inputs-error-text-helper);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  min-height: 11px;\n  margin-top: 5px;\n}\n\n.required {\n  &:after {\n    content: '*';\n    font-size: 10px;\n    line-height: 12px;\n    color: var(--inputs-error-stroke);\n    margin-left: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectWrapper": `selectWrapper__JzbRU`,
	"select": `select__dA9mi`,
	"selectFilled": `selectFilled__tP6sY`,
	"selectDisabled": `selectDisabled__TnNr2`,
	"selectError": `selectError__zO8eo`,
	"selectLabel": `selectLabel__BKAM1`,
	"selectItem": `selectItem__LhoBz`,
	"activeItem": `activeItem__Pqy96`,
	"disabledItem": `disabledItem__ZDQjq`,
	"rtl": `rtl__geCmh`,
	"helperText": `helperText__zP2h4`,
	"required": `required__rIhPo`
};
module.exports = ___CSS_LOADER_EXPORT___;
